import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'slate-react';
import classNames from 'classnames';
import { document } from '../../helpers/BrowserHelpers';

function getMouseEventCaretRange(event) {
  var range;
  var x = event.clientX,
      y = event.clientY;

  if (document.body.createTextRange) {
    // IE way of getting range
    range = document.body.createTextRange();
    range.moveToPoint(x, y);
  } else if (typeof document.createRange !== 'undefined') {
    if (document.caretPositionFromPoint) {
      // Standards-based way
      var pos = document.caretPositionFromPoint(x, y);
      range = document.createRange();
      range.setStart(pos.offsetNode, pos.offset);
      range.collapse(true);
    } else if (document.caretRangeFromPoint) {
      // WebKit way
      range = document.caretRangeFromPoint(x, y);
    }
  }

  return range;
}

var PlaceholderComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(PlaceholderComponent, _Component);

  function PlaceholderComponent(props) {
    var _this;

    _classCallCheck(this, PlaceholderComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PlaceholderComponent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "placeholderRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "onStoreChange", function (store) {
      return _this.setState(store);
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$state = _this.state,
          edition = _this$state.edition,
          selected = _this$state.selected;
      var _this$props = _this.props,
          editor = _this$props.editor,
          node = _this$props.node;

      if (editor.readOnly) {
        return;
      }

      if (!edition && !selected) {
        event.preventDefault();
        event.stopPropagation();
        editor.focus().moveToStartOfNode(node);
      } else if (!edition) {
        event.preventDefault();
        event.stopPropagation();
        var range = getMouseEventCaretRange(event);
        editor.focus().moveTo(range.startOffset);
      }

      editor.command('selectPlaceholder', {
        key: node.key,
        edition: selected
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDoubleClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    _this.state = {
      selected: false,
      edition: false
    };
    props.store.updateItem(props.node.key, _this.state);
    return _this;
  }

  _createClass(PlaceholderComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          store = _this$props2.store,
          node = _this$props2.node;
      store.subscribeToItem(node.key, this.onStoreChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
          store = _this$props3.store,
          node = _this$props3.node,
          editor = _this$props3.editor;
      store.unsubscribeFromItem(node.key, this.onStoreChange);
      editor.command('removePlaceholder', node.key);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          edition = _this$state2.edition,
          selected = _this$state2.selected;
      var _this$props4 = this.props,
          editor = _this$props4.editor,
          children = _this$props4.children,
          attributes = _this$props4.attributes;
      return React.createElement("span", Object.assign({
        className: classNames('editor-placeholder', {
          'edition-mode': edition,
          'read-only': editor.readOnly,
          selected: selected
        }),
        onMouseDown: this.onClick,
        onDoubleClick: this.onDoubleClick,
        ref: this.placeholderRef,
        spellCheck: false
      }, attributes), children);
    }
  }]);

  return PlaceholderComponent;
}(Component);

_defineProperty(PlaceholderComponent, "propTypes", {
  editor: PropTypes.instanceOf(Editor),
  node: PropTypes.object,
  children: PropTypes.node.isRequired,
  store: PropTypes.object,
  attributes: PropTypes.object
});

export default PlaceholderComponent;